<div id="datePicker">
  <label for="myScheduleStartDate">Start Date: &nbsp;</label>
  <p-datepicker id="myScheduleStartDate" [(ngModel)]="startDate" [showIcon]="true" (ngModelChange)="onDateChange()"
    name="myScheduleStartDate"></p-datepicker>
</div>

<hr>

@if (colSize === 0) {
<div id="twoDayCalendar" class="p-grid">
  @for (day of week; track day; let i = $index) {
  <div class="p-col">
    <p-card [style]="{height: '100%', minHeight: '50em'}">
      <ng-template #header>
        {{day | date: 'EEEE M/d' | uppercase}}
      </ng-template>
      @if (!scheduledBucketWeek || !bigDayBucketSubrangeWeek) {
      <div><app-loading-swirly [isLoading]="!scheduledBucketWeek || !bigDayBucketSubrangeWeek"></app-loading-swirly>
      </div>
      }
      @if (scheduledBucketWeek) {
      <div>
        @for (bucket of scheduledBucketWeek[i]; track bucket) {
        <app-my-schedule-crew-card class="scheduled-item" [inputBucket]="bucket">
        </app-my-schedule-crew-card>
        }
      </div>
      }
      @if (bigDayBucketSubrangeWeek) {
      <div>
        @for (bdbSub of bigDayBucketSubrangeWeek[i]; track bdbSub) {
        <app-my-schedule-crew-card class="scheduled-item" [inputBucket]="bdbSub">
        </app-my-schedule-crew-card>
        }
      </div>
      }
    </p-card>
  </div>
  }
</div>
}

@if (colSize !== 0) {
<div id="twoDayCalendar" class="p-grid" style="margin-left: 1em; margin-right: 1em;">
  @for (day of week; track day; let i = $index) {
  <div class="p-col-{{colSize}}" style=" margin-bottom: 1em;">
    <p-card [style]="{height: '100%'}" [header]="day | date: 'EEEE M/d' | uppercase">
      @if (!scheduledBucketWeek || !bigDayBucketSubrangeWeek) {
      <div><app-loading-swirly [isLoading]="!scheduledBucketWeek || !bigDayBucketSubrangeWeek"></app-loading-swirly>
      </div>
      }
      @if (scheduledBucketWeek) {
      <div>
        @for (bucket of scheduledBucketWeek[i]; track bucket) {
        <app-my-schedule-crew-card class="scheduled-item" [inputBucket]="bucket">
        </app-my-schedule-crew-card>
        }
      </div>
      }
      @if (bigDayBucketSubrangeWeek) {
      <div>
        @for (bdbSub of bigDayBucketSubrangeWeek[i]; track bdbSub) {
        <app-my-schedule-crew-card class="scheduled-item" [inputBucket]="bdbSub">
        </app-my-schedule-crew-card>
        }
      </div>
      }
    </p-card>
  </div>
  }
</div>
}